import React from 'react';
import './Finance.scss';
import MolLink from '../../Basepage/parts/Menu/MolLink';

interface RechnungenProp {
  data: any;
  apiBase: string;
}
interface RechnungenState {
  showPosition: number;
}

export default class Rechnungen extends React.Component<
  RechnungenProp,
  RechnungenState
> {
  constructor(prop) {
    super(prop);
    this.state = { showPosition: 10 };
  }

  render(): React.ReactNode {
    let tage = Object.keys(this.props.data.transactions);
    let tageRechungen: string[] = [];
    for (let index = 0; index < tage.length; index++) {
      if (this.props.data.transactions[tage[index]].rechnungen.length > 0) {
        tageRechungen.push(tage[index]);
      }
    }

    let tageCount = tageRechungen.length;
    let showTage = tageRechungen.reverse().slice(0, this.state.showPosition);
    let rows: JSX.Element[] = [];

    let financeTd = (number) => {
      return (
        <td style={{ textAlign: 'right', verticalAlign: 'top' }}>
          {new Intl.NumberFormat('de-DE', {
            style: 'currency',
            currency: 'EUR',
          }).format(number)}
        </td>
      );
    };

    showTage.map((item, index) => {
      let dayTransction = this.props.data.transactions[item];

      for (
        let r_index = 0;
        r_index < dayTransction.rechnungen.length;
        r_index++
      ) {
        let rowId = 'rechnung_' + item + '_' + r_index + '_' + rows.length;
        let classname = 'row ' + (rows.length % 2 == 0 ? 'mod2' : '');
        let lastRow = dayTransction.rechnungen.length - 1 == r_index;
        if (lastRow) {
          classname += ' last';
        }

        let downloadAuftrag = 0;
        let auftrags_positionen = [];
        if (dayTransction.rechnungen[r_index].mol_auftrag_position != null) {
          auftrags_positionen =
            dayTransction.rechnungen[r_index].mol_auftrag_position.split(',');
          downloadAuftrag = auftrags_positionen[0];
        }
        let auftrags_lieferung = [];
        if (dayTransction.rechnungen[r_index].mol_auftrag_lieferung != null) {
          auftrags_lieferung =
            dayTransction.rechnungen[r_index].mol_auftrag_lieferung.split(',');
          if (downloadAuftrag == 0) {
            downloadAuftrag = auftrags_lieferung[0];
          }
        }
        let auftrags_reture = [];
        if (dayTransction.rechnungen[r_index].mol_auftrag_reture != null) {
          auftrags_reture =
            dayTransction.rechnungen[r_index].mol_auftrag_reture.split(',');
          if (downloadAuftrag == 0) {
            downloadAuftrag = auftrags_reture[0];
          }
        }
        let downloadPrefix =
          this.props.apiBase +
          (this.props.apiBase.endsWith('/') ? '' : '/') +
          'Download.php?type=rechnung' +
          '&mol_auftrag_id=' +
          downloadAuftrag;

        let rechnungRow = (
          <tr className={classname} key={rowId} id={rowId}>
            {r_index == 0 ? (
              <td
                rowSpan={dayTransction.rechnungen.length}
                style={{
                  background: 'white',
                  borderBottom: 'solid 1px black',
                }}
              >
                {new Date(item).toLocaleDateString('de-DE', {
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                })}
              </td>
            ) : null}
            <td>
              <a
                href={
                  downloadPrefix +
                  '&filename=' +
                  dayTransction.rechnungen[r_index].rechnungsdatei
                }
                target={'_blank'}
              >
                {dayTransction.rechnungen[r_index].rechnung_typ}{' '}
                {dayTransction.rechnungen[r_index].mol_rechnung_id}{' '}
              </a>

              {auftrags_positionen.length > 0 ? (
                <>
                  <br />
                  Diese Rechnung enthält Positionen aus den Aufträgen:
                  {auftrags_positionen
                    .map((a_item, a_index) => {
                      return (
                        <a href={'/konto/mol_orders/' + a_item} target="_blank">
                          #{a_item}
                        </a>
                      );
                    })
                    .reduce((prev, next) => (
                      <>
                        {prev}
                        {'   '}
                        {next}
                      </>
                    ))}
                </>
              ) : null}
              {auftrags_lieferung.length > 0 ? (
                <>
                  <br />
                  Dies ist die Porto Rechnung zu folgenden Aufträgen:{" "}
                  {auftrags_lieferung
                    .map((a_item, a_index) => {
                      return (
                        <a href={'/konto/mol_orders/' + a_item} target="_blank">
                          #{a_item}
                        </a>
                      );
                    })
                    .reduce((prev, next) => (
                      <>
                        {prev}
                        {'   '}
                        {next}
                      </>
                    ))}
                </>
              ) : null}
               {auftrags_reture.length > 0 ? (
                <>
                  <br />
                  Diese Gutschrift enthält Positionen aus den Aufträgen:{" "}
                  {auftrags_reture
                    .map((a_item, a_index) => {
                      return (
                        <a href={'/konto/mol_orders/' + a_item} target="_blank">
                          #{a_item}
                        </a>
                      );
                    })
                    .reduce((prev, next) => (
                      <>
                        {prev}
                        {'   '}
                        {next}
                      </>
                    ))}
                </>
              ) : null}
            </td>
            {financeTd(dayTransction.rechnungen[r_index].betrag)}
          </tr>
        );
        rows.push(rechnungRow);
      }
    });

    return (
      <div id="Finance">
        <div>
          <table>
            <thead>
              <tr>
                <th>Tag</th>
                <th colSpan={2}>Rechnungen</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r_item, r_index) => r_item)}
              {tageCount > this.state.showPosition ? (
                <tr>
                  <td
                    colSpan={6}
                    style={{ textAlign: 'center', cursor: 'pointer' }}
                    onClick={() => {
                      let newShow = {
                        showPosition: this.state.showPosition + 10,
                      };

                      this.setState(newShow);
                    }}
                  >
                    … weitere Rechnungen
                  </td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}
